import store from '../store/index';

// 计算春节日期（简单算法：根据已知年份的春节日期推算）
function getSpringFestivalDates(year = new Date().getFullYear()) {
  // 已知年份的春节日期（数据来源：国务院办公厅发布的节假日安排）
  const springFestivalData = {
    2025: { start: '2025-01-29', end: '2025-02-04' },
    2026: { start: '2026-02-17', end: '2026-02-23' },
    2027: { start: '2027-02-06', end: '2027-02-12' },
    2028: { start: '2028-01-26', end: '2028-02-01' },
    2029: { start: '2029-02-13', end: '2029-02-19' },
    2030: { start: '2030-02-03', end: '2030-02-09' },
  };

  // 如果已知年份，直接返回
  if (springFestivalData[year]) {
    return springFestivalData[year];
  }

  // 未知年份使用默认值（根据19年一次的周期进行推算）
  const baseYear = 2026;
  const offset = (year - baseYear) % 19;

  // 简单的推算（实际应用建议使用农历算法库）
  // 这里使用一个简单的算法，根据已知年份进行偏移
  let month = 2;
  let day = 17;

  if (offset === 1) {
    month = 2;
    day = 6;
  } else if (offset === 2) {
    month = 1;
    day = 26;
  } else if (offset === 3) {
    month = 2;
    day = 13;
  } else if (offset === 4) {
    month = 2;
    day = 3;
  } else if (offset === 5) {
    month = 1;
    day = 23;
  } else if (offset === 6) {
    month = 2;
    day = 11;
  } else if (offset === 7) {
    month = 1;
    day = 31;
  } else if (offset === 8) {
    month = 2;
    day = 19;
  } else if (offset === 9) {
    month = 2;
    day = 8;
  } else if (offset === 10) {
    month = 1;
    day = 29;
  } else if (offset === 11) {
    month = 2;
    day = 16;
  } else if (offset === 12) {
    month = 2;
    day = 5;
  } else if (offset === 13) {
    month = 1;
    day = 25;
  } else if (offset === 14) {
    month = 2;
    day = 13;
  } else if (offset === 15) {
    month = 2;
    day = 2;
  } else if (offset === 16) {
    month = 1;
    day = 22;
  } else if (offset === 17) {
    month = 2;
    day = 10;
  } else if (offset === 18) {
    month = 1;
    day = 30;
  }

  const startDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
  const startDateObj = new Date(startDate);
  const endDateObj = new Date(startDateObj);
  endDateObj.setDate(startDateObj.getDate() + 6);

  return {
    start: startDate,
    end: `${endDateObj.getFullYear()}-${(endDateObj.getMonth() + 1).toString().padStart(2, '0')}-${endDateObj
      .getDate()
      .toString()
      .padStart(2, '0')}`,
  };
}

// 获取节假日日期
function getHolidayDates(year, holiday) {
  // 春节假期
  if (holiday === '春节假期' || holiday === '春节') {
    return getSpringFestivalDates(year);
  }
  // 五一小长假
  if (holiday === '五一小长假' || holiday === '劳动节') {
    const mayDayStart = `${year}-05-01`;
    const mayDayEnd = `${year}-05-05`;
    return { start: mayDayStart, end: mayDayEnd };
  }
  // 国庆黄金周
  if (holiday === '国庆黄金周' || holiday === '国庆节') {
    const nationalDayStart = `${year}-10-01`;
    const nationalDayEnd = `${year}-10-07`;
    return { start: nationalDayStart, end: nationalDayEnd };
  }
  // 默认返回当前月
  return {
    start: `${year}-01-01`,
    end: `${year}-12-31`,
  };
}

export const dateFormat = function(fmt, date) {
  let ret;
  const opt = {
    'Y+': date.getFullYear().toString(), // 年
    'm+': (date.getMonth() + 1).toString(), // 月
    'd+': date.getDate().toString(), // 日
    'H+': date.getHours().toString(), // 时
    'M+': date.getMinutes().toString(), // 分
    'S+': date.getSeconds().toString(), // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp('(' + k + ')').exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
    }
  }
  return fmt;
};

export const getHour = function(hour) {
  var today = new Date();
  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * hour;
  today.setTime(targetday_milliseconds);
  var tHour = today.getHours();
  return tHour;
};

//生成从minNum到maxNum的随机数
export const randomNum = function(minNum, maxNum) {
  switch (arguments.length) {
    case 1:
      return parseInt(Math.random() * minNum + 1, 10);
    case 2:
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
    default:
      return 0;
  }
};

export function getTimeYear(yeer = false) {
  var YearData = {};
  if (yeer.length == 4) {
    YearData = yeer;
  }
  return YearData;
}

export function getTimeMonth(moo = false) {
  var mooData = {};
  if (moo) {
    // console.log(moo, '3w45q13453');
    mooData = Number(moo);
  }
  return mooData;
}

export class CreateIntervalTask {
  static IntervalTasksIdList = [];
  constructor(cb, timer = 1000) {
    this.timer = timer;
    this.cb = cb;
    this.TimerId = setInterval(() => {
      cb();
    }, timer);
    CreateIntervalTask.IntervalTasksIdList.push(this.TimerId);
  }
  cancel() {
    clearInterval(this.TimerId);
  }
  static cancelAll() {
    CreateIntervalTask.IntervalTasksIdList.forEach(id => {
      clearInterval(id);
    });
  }
}

export function getFilterValue(value) {
  console.log(value, 'kkkkkkkkkk');

  if (typeof value === 'string') {
    switch (value) {
      case 'month':
        return `${new Date().getFullYear()}-${(new Date().getMonth() + 1).toString().padStart(2, '0')}`;
      case 'quarter':
        return `${new Date().getDate()}-${new Date()
          .getDate()
          .toString()
          .padStart(2, '0')}`;
      case 'day':
        return `${new Date().getFullYear()}-${(new Date().getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${new Date()
          .getDate()
          .toString()
          .padStart(2, '0')}`;
      case 'dayStart':
        return `${new Date().getFullYear()}-${(new Date().getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${new Date()
          .getDate()
          .toString()
          .padStart(2, '0')} 00:00:00`;
      case 'montStart':
        return `${new Date().getFullYear()}-${(new Date().getMonth() + 1)
          .toString()
          .padStart(2, '0')}-01 00:00:00`;
      case 'dayEnd':
        return `${new Date().getFullYear()}-${(new Date().getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${new Date()
          .getDate()
          .toString()
          .padStart(2, '0')} 23:59:59`;
      case 'hh':
        return `${new Date().getFullYear()}-${(new Date().getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${new Date()
          .getDate()
          .toString()
          .padStart(2, '0')} ${new Date()
          .getHours()
          .toString()
          .padStart(2, '0')}`;
      case '01':
        return `${new Date().getFullYear()}-${(new Date().getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${new Date()
          .getDate()
          .toString()
          .padStart(2, '0')} 01`;
      case 'singleYear':
        return `${new Date().getFullYear()}`;
      case 'monthly':
        return new Date().getMonth() + 1;
      case 'motTime':
        const motDate = new Date();
        motDate.setDate(motDate.getDate() - 30);
        return `${motDate.getFullYear()}-${(motDate.getMonth() + 1).toString().padStart(2, '0')}-${motDate
          .getDate()
          .toString()
          .padStart(2, '0')} 00:00:00`;
      case 'monthDaySecond':
        return `${new Date().getFullYear()}-01-01 00:00:00`;
      case 'time':
        return `${new Date().getFullYear()}${(new Date().getMonth() + 1)
          .toString()
          .padStart(2, '0')}${new Date()
          .getDate()
          .toString()
          .padStart(2, '0')}${new Date()
          .getHours()
          .toString()
          .padStart(2, '0')}${new Date()
          .getMinutes()
          .toString()
          .padStart(2, '0')}${new Date()
          .getSeconds()
          .toString()
          .padStart(2, '0')}`;
      case 'fileDate':
        return `${new Date().getFullYear()}${(new Date().getMonth() + 1)
          .toString()
          .padStart(2, '0')}${new Date()
          .getDate()
          .toString()
          .padStart(2, '0')}`;
      case 'realTime':
        return `${new Date()
          .getHours()
          .toString()
          .padStart(2, '0')}:${new Date()
          .getMinutes()
          .toString()
          .padStart(2, '0')}:${new Date()
          .getSeconds()
          .toString()
          .padStart(2, '0')}`;
      case 'newYear':
        return { kind: 'year' };
      case 'newHalfyear':
        return { kind: 'halfyear' };
      case 'newQuarter':
        return { kind: 'quarter' };
      case 'Month':
        return { kind: 'month' };
      case 'newMonth':
        return 'month';
      case 'newDay':
        return 'day';
      case '总数':
        return '总数';
      case 'holidays':
        const currentYear = new Date().getFullYear();
        const holidayDates = getSpringFestivalDates(currentYear);
        return {
          date_filed: 'statistical_date',
          date_start: holidayDates.start,
          date_end: holidayDates.end,
          order_by: 'sumNums desc',
        };
      case 'popularFeelings':
        return {
          name: '总数',
          order_by: 'statistical_date  asc',
          date_filed: 'statistical_date',
          date_start: `${new Date().getFullYear()}-${(new Date().getMonth() + 1)
            .toString()
            .padStart(2, '0')}-01`,
          date_end: `${new Date().getFullYear()}-${(new Date().getMonth() + 1)
            .toString()
            .padStart(2, '0')}-30`,
        };
    }

    // Handle general string cases (original logic from line 249)
    if (/[A-Za-z]+$/.test(value)) {
      // Handle pure letters (e.g., 'month', 'day')
      return { kind: value };
    } else if (/^[\u4e00-\u9fa5]+$/.test(value)) {
      // Handle Chinese characters
      return { param: value };
    } else if (/^\d{4}-\d{2}$/.test(value)) {
      // Handle date ranges like '2025-03'
      const [year, month] = value.split('-');
      const startDate = `${year}-${month}-01`;
      const lastDay = new Date(year, month, 0).getDate(); // Get the last day of the month
      const endDate = `${year}-${month}-${lastDay}`; // Use the last day of the month
      return { start_date: startDate, end_date: endDate };
    } else if (/^\d{4}$/.test(value)) {
      // Handle years like '2025'
      return { year: value, date: value, date_start: value, date_end: value };
    } else {
      // Handle other strings (e.g., '2025-03-01')
      return {
        data: value,
        day: value,
        date_start: value,
        date_end: value,
      };
    }
  }

  if (Array.isArray(value)) {
    if (value.length === 3 && value[0] === 'timekey') {
      const [_, startDate, endDate] = value;
      return { start_date: startDate, end_date: endDate };
    } else if (value[0] === 'tabDat1') {
      return {
        data: {
          sentiment_all: '1,2,9',
          date_start: `${value[1]} 00:00:00`,
          date_end: `${value[2]} 23:59:59`,
          order_by: 'ctime desc',
          date_filed: 'ctime',
        },
      };
    } else if (value[0] === 'tabDat2') {
      return {
        data: {
          sentiment_all: '0,-1,-2',
          date_start: `${value[1]} 00:00:00`,
          date_end: `${value[2]} 23:59:59`,
          order_by: 'ctime desc',
          date_filed: 'ctime',
        },
      };
    } else if (value[0] === 'tabDat3') {
      return {
        data: {
          sentiment_all: '-5,-6',
          date_start: `${value[1]} 00:00:00`,
          date_end: `${value[2]} 23:59:59`,
          order_by: 'ctime desc',
          date_filed: 'ctime',
        },
      };
    } else if (value[3] === 'city') {
      // Handle ['city', '2025-04-01', '2025-04-30', 'city']
      return {
        startTime: `${value[1]} 00:00:00`,
        endTime: `${value[2]} 23:59:59`,
        kind: 'City',
      };
    } else if (value[3] === 'age' || value[3] === 'sex') {
      // Handle ['age', '2025-04-01', '2025-04-30', 'age']
      return {
        startTime: `${value[1]} 00:00:00`,
        endTime: `${value[2]} 23:59:59`,
      };
    } else if (value[3] === 'province') {
      // Handle ['province', '2025-04-01', '2025-04-30', 'province']
      return {
        startTime: `${value[1]} 00:00:00`,
        endTime: `${value[2]} 23:59:59`,
        kind: 'Province',
      };
    } else if (value[0] === 'tabPoint') {
      // Handle ['tabPoint', '2025-04-01', '2025-04-30']
      return {
        beginTime: `${value[2]} 00:00:00`,
        endTime: `${value[2]} 23:59:59`,
      };
    } else if (value[0] === 'holidays' && value[1] && value[2]) {
      // 处理 ['holidays', year, holiday] 结构
      const year = value[1];
      const holiday = value[2];
      const holidayDates = getHolidayDates(Number(year), holiday);
      return {
        data: {
          date_filed: 'statistical_date',
          date_start: holidayDates.start,
          date_end: holidayDates.end,
          order_by: 'sumNums desc',
        },
      };
    }
  }

  // Handle numbers (new logic)
  if (typeof value === 'number') {
    return { date: value.toString() };
  }

  // Handle objects (new logic)
  if (typeof value === 'object' && value !== null) {
    return value;
  }

  // Default case
  return { data: value, day: value };
}
// 获取视频流
export function getVideoStreaming(flow) {
  return flow;
}

// 跳转链接
export function jumpSomePlaceByLink(type, url) {
  if (type == 'inner') {
    document.querySelector('#' + url).click();
  } else {
    window.open(url, '_blank');
  }
}
// 播放音频
export async function playAudio(list, delay) {
  // 音频列表
  if (list instanceof Array) {
    if (list.length == 0) {
      store.commit('setIsAudioPlaying', false);
      return;
    }
    for (let i = 0; i < list.length; i++) {
      console.log('[ 播放音频 ] >');
      await playSingleAudio(list[i], delay);
      if (i == list.length - 1) {
        store.commit('setIsAudioPlaying', false);
      }
      continue;
    }
  } else {
    await playSingleAudio(list, delay);
    store.commit('setIsAudioPlaying', false);
  }
}

function playSingleAudio(url, delay = 1000) {
  let player = new Audio(url);
  return new Promise((resolve, reject) => {
    player.play();

    // 监听播放完毕
    player.addEventListener('ended', end);

    function end() {
      console.log('[ 播放完毕 ] >');
      // 移除监听
      player.removeEventListener('ended', end);

      // delay时间后再resolve
      setTimeout(() => {
        resolve(true);
      }, delay);
    }
  });
}
